<template>
    <el-drawer 
        title="添加白名单用户" 
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        :show-close="false"
    >
        <div class="drawer-content">
            <el-form :model="addwhitelistForm"  ref="addwhitelistForm">                
				<el-form-item  prop="userId" label="白名单用户:" :rules="[{required: true, message: '请填写用户ID'}]">					
					<el-select
					    v-model="addwhitelistForm.userId" 
					    filterable 
					    remote
					    placeholder="请填写用户ID"
					    :remote-method="searchArtist"
					    :loading="userLoading"
					    size="medium">
					    <el-option
					        v-for="item in artistList"
					        :key="item.id"
					        :label="item.name + '/' + item.id"
					        :value="item.id">
					    </el-option>
					</el-select>
				</el-form-item>                
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submitForm" :loading="submitLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
import {fetchUser} from '@/assets/js/commonApi';
export default {
    props:{
        id:{
            type:[Number,String],
            default:1
        }
    },
    data(){       
      return {
		userLoading:false,
		submitLoading: false,		
        drawerShow:false,
		addwhitelistForm:{
			userId:''
		},
		artistList:{}
      }  
    },
    watch:{
       
    },
    methods: {
		show() {
			this.drawerShow = true;
		},
		close(){		    
			this.drawerShow = false;
			this.addwhitelistForm.userId = ''
		},
		// 搜索用户
		async searchUser(query,userType,name){
			if(query !== ""){
				this.userLoading = true;
				const res = await fetchUser({
					queryValue:query,
					userType:userType,
				}).finally(() => {
					this.userLoading = false;
				});
				
				const { state, result } = res.data;
				
				if (state == 1 && result) {
					this.artistList = result;
					console.log(this.artistList)
				}
			}
		},
		searchArtist(query){
			this.searchUser(query,0,'artistList');
		},
        submitForm(){
			console.log(this.addwhitelistForm.userId)
			console.log(this.id)
			//return
            this.$refs['addwhitelistForm'].validate((valid) => {
                if(valid){
                    this.submitLoading = true;
                    this.$request({
                        url: '/shopGoodsWhite/add',
                        method: "POST",
                        params:{userId:this.addwhitelistForm.userId,goodsId:this.id}
                    }).then(res=>{
                        const {state, msg} = res.data;
                        if (state == 1) {
                            this.$message.success('操作成功');                            
                            this.$emit('update');
							this.close()
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    }).catch(() => {
                        this.$message.error("请求错误");
                    }).finally(()=>{
                        this.submitLoading = false;
                    })
                }
            })            
        },
        
    }
}
</script>